"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_luxury_estate_exterior.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_luxury_estate_exterior.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_luxury_estate_exterior.png-wvc-sizes",
  alt: "Modern luxury estate exterior with clean architectural lines in Austin"
}, {
  src: "https://gfccontractors.com/wp-content/uploads/2026/08/OIG4-12.jpeg?v=xkiz5xgxahq",
  srcset: "https://gfccontractors.com/wp-content/uploads/2026/08/OIG4-12.jpeg?v=venbqlf71g-wvc-srcset",
  sizes: "https://gfccontractors.com/wp-content/uploads/2026/08/OIG4-12.jpeg?v=2feijjsgrfb-wvc-sizes",
  alt: "High-end kitchen renovation with custom cabinetry"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/residential_addition_project.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/residential_addition_project.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/residential_addition_project.png-wvc-sizes",
  alt: "Luxury residential home addition and expansion"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_new_construction_build.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_new_construction_build.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_new_construction_build.png-wvc-sizes",
  alt: "New construction luxury estate in Austin"
}, {
  src: "https://gfccontractors.com/wp-content/uploads/2026/08/OIG4.p1cTy2uxmHhueQov5.jpeg?v=nuh6nndxa9o",
  srcset: "https://gfccontractors.com/wp-content/uploads/2026/08/OIG4.p1cTy2uxmHhueQov5.jpeg?v=rm3xf5n8oj-wvc-srcset",
  sizes: "https://gfccontractors.com/wp-content/uploads/2026/08/OIG4.p1cTy2uxmHhueQov5.jpeg?v=29xc7jtcgph-wvc-sizes",
  alt: "Elegant master bedroom suite with bespoke millwork"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_estate_backyard_view.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_estate_backyard_view.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_estate_backyard_view.png-wvc-sizes",
  alt: "Completed luxury estate backyard and landscaping project"
}];
export default function ProjectGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="254929" id="project-gallery" ref={ref} className={`py-24 bg-background text-foreground overflow-hidden transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
            <div className="max-w-2xl">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-4 tracking-widest uppercase">
                INSPIRATION GALLERY
              </h2>
              <p className="text-lg text-muted-foreground font-mono tracking-wide">
                A selection of our luxury custom homes and remodeling projects across Austin, showcasing excellence in every detail.
              </p>
            </div>

            <div className="hidden md:flex items-center gap-3 shrink-0">
              <CarouselPrevious className="static translate-y-0 translate-x-0 size-10 rounded-md bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground border border-foreground shadow-sm transition-colors" />
              <CarouselNext className="static translate-y-0 translate-x-0 size-10 rounded-md bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground border border-foreground shadow-sm transition-colors" />
            </div>
          </div>

          <CarouselContent className="-ml-4 md:-ml-6">
            {galleryImages.map((image, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 basis-[85%] md:basis-2/3 lg:basis-[60%]">
                <div className="overflow-hidden rounded-md shadow-md group bg-muted">
                  <AspectRatio ratio={16 / 9}>
                    <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" />
                    <div className="absolute inset-0 pointer-events-none rounded-md border border-foreground/5" />
                  </AspectRatio>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex md:hidden items-center justify-center gap-4 mt-8">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-10 rounded-md bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground border border-foreground shadow-sm" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-10 rounded-md bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground border border-foreground shadow-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}